import React from 'react';
import { Bar } from 'react-chartjs-2';

const BarChart = ({ dataValue, barOptions, ...rest }) => {
  return <Bar data={dataValue} {...rest} options={barOptions} />;
};
export default BarChart;
